var customTextValue;
(function( w, $ ) {
	personalizer = function (_sku,_debug){
		var canvas = document.getElementById('canvas'),
		ctx = canvas.getContext('2d');
		ctx.fillStyle = "rgba(255, 255, 255, 0)";
		ctx.fillRect(0, 0, canvas.width, canvas.height);
		if(!_debug){
			_debug = 0;
		}
		var debug = _debug;
		var showBounds = 0;
		var originalFontSize = 242;
		var originalRatio = ratio = 1;
		var gutter = 0;// gutter around boundary?
		var verticalAlignment = 'center';// top,center,bottom
		var horizontalAlignment = 'center';// left,center,right
		var pcode = _sku.toUpperCase();
		var fontFamilyBase = "helvetica_roundedbold";
		var primaryFontColor = "#FFFFFF";//
		var primaryFontColor2 = false;
		var gradientDirection = "vertical";
		var gradOffset = 0;// 0-0.49 moves gradient as % within a letter box
		var dropshadow = false;
		var dropshadowScale = true;
		var shadowFontColor = "rgba(0, 0, 0, .5)";//
		var shadowBlur = 0;
		var shadowOffsetX = 0;
		var shadowOffsetY = 0;			
		var	centerRotationDeg = 0;
		var centerRotationX = 0;
		var centerRotationY = 0;
		var caseRule = "lowercase";// none / capitalize / uppercase / lowercase
		var fontSizeRatio = 1.6;//only change for central vertical alignment
		var bespokeValue = "";
		var bespokePrefix = "";
		var bespokeSuffix = "";
		var bespokeSuffix2 = "";
		var stroke = false;
		var strokeScale = true;
		var strokeColor = "#FF00FF";
		var strokeWidth = 0;
		var strokeBlur = 0;
		var stroke2 = false;
		var strokeWidth2 = 0;
		var strokeBlur2 = 0;			
		var xL = canvas.width*gutter;//0: fullWidth
		var yT = 0;//0: fullHeight
		var xR = canvas.width-xL;//canvas.width: fullWidth
		var yB = 0;//canvas.height: fullHeight
	    var canvasHeight = 1024;
		var canvasWidth = 1024;
		var productType = "";
		var orientation = "";// landscape,portrait
		var zoom = 1;
		
		if(pcode){
			//REMOVE ATTRIBUTES
            //console.log("before: "+pcode);
			if(pcode.indexOf('PPRINT') >=0){
          		//console.log('instance of PPRINT found');
				//pcode = pcode.replace('_PPRINT_20x20','_PPRINT');
				//pcode = pcode.replace('_PPRINT_40x40','_PPRINT');
				//pcode = pcode.replace('_PPRINTFRAMEDWHITE_20X20','_PPRINT');
				//pcode = pcode.replace('_PPRINTFRAMEDWHITE_40x40','_PPRINT');
              	var pcode_arr = pcode.split("_");
	            pcode = pcode_arr[0]+'_PPRINT';
          		//console.log("after: "+pcode);
            }
          
			if(pcode.indexOf('PAPRON') >=0){
				pcode = pcode.replace('_PAPRON_KIDS','_PAPRON');
				pcode = pcode.replace('_PAPRON_ADULT','_PAPRON');
			}
          	if(pcode.indexOf('PBABYGROW') >= 0){
          		pcode = pcode.replace('_PBABYGROW_0-3','_PBABYGROW');
          		pcode = pcode.replace('_PBABYGROW_3-6','_PBABYGROW');
          		pcode = pcode.replace('_PBABYGROW_6-12','_PBABYGROW');
          		pcode = pcode.replace('_PBABYGROW_12-18','_PBABYGROW');
          		pcode = pcode.replace('_PBABYGROW_0','_PBABYGROW');
          	}
			if(pcode.indexOf('PLUNCH') >=0){
				pcode = pcode.replace('_PLUNCH-BLU','_PLUNCH');
				pcode = pcode.replace('_PLUNCH-PIN','_PLUNCH');
				pcode = pcode.replace('_PLUNCH_BLU','_PLUNCH');
				pcode = pcode.replace('_PLUNCH_PIN','_PLUNCH');
			}
			if(pcode.indexOf('PPHONE') >=0){
				pcode = pcode.replace('_PPHONE_IPHONE6','_PPHONE');
				pcode = pcode.replace('_PPHONE_IPHONE7','_PPHONE');
				pcode = pcode.replace('_PPHONE_IPHONE6PLUS','_PPHONE');
				pcode = pcode.replace('_PPHONE_IPHONE7PLUS','_PPHONE');
				pcode = pcode.replace('_PPHONE_IPHONE8','_PPHONE');
			}
			if(pcode.indexOf('PSQPRINT') >=0){
				pcode = pcode.replace('_PSQPRINT_SML','_PSQPRINT');
				pcode = pcode.replace('_PSQPRINT_LRG','_PSQPRINT');
				pcode = pcode.replace('_PSQPRINTFRAMEDWHITE_SML','_PSQPRINT');
				pcode = pcode.replace('_PSQPRINTFRAMEDWHITE_LRG','_PSQPRINT');
			}
			if(pcode.indexOf('PTSHIRT') >=0){
				pcode = pcode.replace('_PTSHIRT-1','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT-1','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT-2','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT-3','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT-4','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT-5','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT-6','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT-7','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT-8','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT-9','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT-10','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT-11','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT_1-2','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT_3-4','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT_5-6','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT_7-8','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT_9-10','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT_9-11','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT_12-14','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT_SML','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT_MED','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT_LRG','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT_XL','_PTSHIRT');
				pcode = pcode.replace('_PTSHIRT_XXL','_PTSHIRT');
			}
			var productArray = [];

			//===============
			// BONE CHINA MUGS
			//===============
			productArray.push({
				sku:"PMIFF005_PBCM",
				originalFontSize:43,
				primaryFontColor:"black",
				xL:30,
				yT:135,
				xR:315,
				yB:192,
				bespokeValue:"melanie",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF008_PBCM",
				originalFontSize:44,
				primaryFontColor:"black",
				xL:20,
				yT:111,
				xR:325,
				yB:180,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF010_PBCM",
				originalFontSize:44,
				primaryFontColor:"black",
				xL:20,
				yT:121,
				xR:339,
				yB:184,
				bespokeValue:"miffy",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF011_PBCM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:45,
				yT:190,
				xR:300,
				yB:238,
				bespokeValue:"miffy!",
				bespokeSuffix:"!",
				bespokeSuffix2:"!",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF012_PBCM",
				originalFontSize:44,
				primaryFontColor:"black",
				xL:25,
				yT:178,
				xR:335,
				yB:238,
				bespokeValue:"miffy",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF014_PBCM",
				originalFontSize:44,
				primaryFontColor:"black",
				xL:38,
				yT:148,
				xR:310,
				yB:210,
				bespokeValue:"miffy",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF015_PBCM",
				originalFontSize:44,
				primaryFontColor:"black",
				xL:25,
				yT:148,
				xR:310,
				yB:210,
				bespokeValue:"miffy",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF017_PBCM",
				originalFontSize:44,
				primaryFontColor:"black",
				xL:25,
				yT:148,
				xR:320,
				yB:210,
				bespokeValue:"melanie",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF018_PBCM",
				originalFontSize:48,
				primaryFontColor:"black",
				xL:25,
				yT:148,
				xR:320,
				yB:210,
				bespokeValue:"melanie",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF020_PBCM",
				originalFontSize:48,
				primaryFontColor:"black",
				xL:30,
				yT:124,
				xR:320,
				yB:200,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF021_PBCM",
				originalFontSize:48,
				primaryFontColor:"black",
				xL:30,
				yT:144,
				xR:315,
				yB:210,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF025_PBCM",
				originalFontSize:48,
				primaryFontColor:"black",
				xL:50,
				yT:130,
				xR:312,
				yB:204,
				bespokeValue:"miffy",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF027_PBCM",
				originalFontSize:48,
				primaryFontColor:"black",
				xL:40,
				yT:135,
				xR:305,
				yB:200,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF029_PBCM",
				originalFontSize:56,
				primaryFontColor:"black",
				xL:30,
				yT:158,
				xR:320,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF030_PBCM",
				originalFontSize:48,
				primaryFontColor:"black",
				xL:45,
				yT:170,
				xR:300,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF033_PBCM",
				originalFontSize:48,
				primaryFontColor:"black",
				xL:25,
				yT:190,
				xR:325,
				yB:257,
				bespokeValue:"miffy",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF035_PBCM",
				originalFontSize:48,
				primaryFontColor:"black",
				xL:50,
				yT:134,
				xR:325,
				yB:210,
				bespokeValue:"miffy",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF036_PBCM",
				originalFontSize:48,
				primaryFontColor:"black",
				xL:25,
				yT:184,
				xR:323,
				yB:270,
				bespokeValue:"miffy",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF037_PBCM",
				originalFontSize:48,
				primaryFontColor:"black",
				xL:48,
				yT:174,
				xR:300,
				yB:220,
				bespokeValue:"miffy!",
				bespokeSuffix:"!",
				bespokeSuffix2:"!",
				canvasHeight:403,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF038_PBCM",
				originalFontSize:48,
				primaryFontColor:"black",
				xL:48,
				yT:150,
				xR:338,
				yB:210,
				bespokeValue:"miffy",
				canvasHeight:403,
				canvasWidth:1024
			});
			//===============
			// COLOURED INSERT MUGS
			//===============
			productArray.push({
				sku:"PMIFF005_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:358,
				yB:210,
				bespokeValue:"melanie",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF008_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:50,
				yT:145,
				xR:340,
				yB:200,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF010_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:25,
				yT:145,
				xR:365,
				yB:180,
				bespokeValue:"miffy",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF011_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:50,
				yT:200,
				xR:340,
				yB:260,
				bespokeValue:"miffy!",
				bespokeSuffix:"!",
				bespokeSuffix2:"!",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF012_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:47,
				yT:190,
				xR:340,
				yB:260,
				bespokeValue:"miffy",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF014_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:60,
				yT:160,
				xR:328,
				yB:210,
				bespokeValue:"miffy",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF015_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:50,
				yT:155,
				xR:340,
				yB:210,
				bespokeValue:"miffy",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF017_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:50,
				yT:155,
				xR:340,
				yB:210,
				bespokeValue:"melanie",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF018_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:50,
				yT:155,
				xR:340,
				yB:210,
				bespokeValue:"melanie",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF020_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:48,
				yT:135,
				xR:340,
				yB:190,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF021_PCIM",
				originalFontSize:44,
				primaryFontColor:"black",
				xL:50,
				yT:150,
				xR:353,
				yB:215,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF025_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:20,
				yT:130,
				xR:365,
				yB:207,
				bespokeValue:"miffy",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF027_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:50,
				yT:146,
				xR:340,
				yB:198,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF029_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:50,
				yT:160,
				xR:338,
				yB:222,
				bespokeValue:"miffy",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF030_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:50,
				yT:183,
				xR:335,
				yB:255,
				bespokeValue:"miffy",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF033_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:50,
				yT:190,
				xR:338,
				yB:255,
				bespokeValue:"miffy",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF035_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:50,
				yT:150,
				xR:335,
				yB:230,
				bespokeValue:"miffy",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF036_PCIM",
				originalFontSize:44,
				primaryFontColor:"black",
				xL:60,
				yT:160,
				xR:328,
				yB:225,
				bespokeValue:"miffy",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF037_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:60,
				yT:160,
				xR:328,
				yB:232,
				bespokeValue:"miffy!",
				bespokeSuffix:"!",
				bespokeSuffix2:"!",
				canvasHeight:409,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF038_PCIM",
				originalFontSize:45,
				primaryFontColor:"black",
				xL:65,
				yT:120,
				xR:320,
				yB:195,
				bespokeValue:"miffy",
				canvasHeight:409,
				canvasWidth:1024
			});
			//===============
			// COASTERS
			//===============
			productArray.push({
				sku:"PMIFF005_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:103,
				yT:130,
				xR:890,
				yB:245,
				bespokeValue:"melanie",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF008_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:103,
				yT:130,
				xR:920,
				yB:250,
				bespokeValue:"miffy!",
				bespokeSuffix:"!",
				bespokeSuffix2:"!",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF010_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:103,
				yT:30,
				xR:920,
				yB:155,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF011_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:103,
				yT:130,
				xR:920,
				yB:250,
				bespokeValue:"miffy!",
				bespokeSuffix:"!",
				bespokeSuffix2:"!",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF012_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:103,
				yT:120,
				xR:920,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF014_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:103,
				yT:130,
				xR:920,
				yB:250,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF015_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:103,
				yT:30,
				xR:920,
				yB:145,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF017_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:103,
				yT:20,
				xR:920,
				yB:125,
				bespokeValue:"melanie",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF018_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:103,
				yT:120,
				xR:920,
				yB:245,
				bespokeValue:"melanie",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF020_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:103,
				yT:60,
				xR:923,
				yB:157,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF021_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:103,
				yT:50,
				xR:923,
				yB:150,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF025_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:100,
				yT:42,
				xR:923,
				yB:150,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF027_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:100,
				yT:40,
				xR:923,
				yB:146,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF029_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:100,
				yT:40,
				xR:923,
				yB:155,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF030_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:100,
				yT:120,
				xR:923,
				yB:222,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF033_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:100,
				yT:35,
				xR:923,
				yB:152,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF035_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:100,
				yT:35,
				xR:923,
				yB:152,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF036_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:100,
				yT:140,
				xR:923,
				yB:232,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF037_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:100,
				yT:140,
				xR:923,
				yB:232,
				bespokeValue:"miffy!",
				bespokeSuffix:"!",
				bespokeSuffix2:"!",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF038_PCOAST",
				originalFontSize:97,
				primaryFontColor:"black",
				xL:100,
				yT:35,
				xR:896,
				yB:155,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			//===============
			// CUSHIONS
			//===============
			productArray.push({
				sku:"PMIFF005_PCUSHION",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:100,
				yT:155,
				xR:923,
				yB:285,
				bespokeValue:"melanie",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF008_PCUSHION",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:100,
				yT:155,
				xR:923,
				yB:288,
				bespokeValue:"miffy!",
				bespokeSuffix:"!",
				bespokeSuffix2:"!",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF010_PCUSHION",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:100,
				yT:95,
				xR:923,
				yB:200,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF011_PCUSHION",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:100,
				yT:90,
				xR:923,
				yB:190,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF012_PCUSHION",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:100,
				yT:170,
				xR:920,
				yB:260,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF014_PCUSHION",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:100,
				yT:90,
				xR:923,
				yB:190,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF015_PCUSHION",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:100,
				yT:170,
				xR:923,
				yB:277,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF017_PCUSHION",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:100,
				yT:170,
				xR:923,
				yB:272,
				bespokeValue:"melanie",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF018_PCUSHION",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:100,
				yT:90,
				xR:923,
				yB:194,
				bespokeValue:"melanie",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF020_PCUSHION",
				originalFontSize:80,
				primaryFontColor:"black",
				xL:100,
				yT:100,
				xR:923,
				yB:204,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF021_PCUSHION",
				originalFontSize:80,
				primaryFontColor:"black",
				xL:100,
				yT:100,
				xR:923,
				yB:204,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF025_PCUSHION",
				originalFontSize:80,
				primaryFontColor:"black",
				xL:100,
				yT:180,
				xR:923,
				yB:264,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF027_PCUSHION",
				originalFontSize:80,
				primaryFontColor:"black",
				xL:100,
				yT:85,
				xR:923,
				yB:194,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF029_PCUSHION",
				originalFontSize:80,
				primaryFontColor:"black",
				xL:100,
				yT:85,
				xR:923,
				yB:194,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF030_PCUSHION",
				originalFontSize:80,
				primaryFontColor:"black",
				xL:100,
				yT:160,
				xR:923,
				yB:254,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF033_PCUSHION",
				originalFontSize:80,
				primaryFontColor:"black",
				xL:100,
				yT:85,
				xR:923,
				yB:194,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF035_PCUSHION",
				originalFontSize:80,
				primaryFontColor:"black",
				xL:100,
				yT:85,
				xR:923,
				yB:194,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF036_PCUSHION",
				originalFontSize:80,
				primaryFontColor:"black",
				xL:100,
				yT:180,
				xR:923,
				yB:264,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF037_PCUSHION",
				originalFontSize:80,
				primaryFontColor:"black",
				xL:100,
				yT:89,
				xR:923,
				yB:199,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF038_PCUSHION",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:100,
				yT:110,
				xR:923,
				yB:224,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			//===============
			// DOOR PLAQUES
			//===============
			productArray.push({
				sku:"PMIFF005_PDRPLQ",
				originalFontSize:95,
				primaryFontColor:"black",
				xL:10,
				yT:258,
				xR:500,
				yB:358,
				bespokeValue:"melanie's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF008_PDRPLQ",
				originalFontSize:138,
				primaryFontColor:"black",
				xL:10,
				yT:200,
				xR:500,
				yB:386,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF010_PDRPLQ",
				originalFontSize:138,
				primaryFontColor:"black",
				xL:10,
				yT:200,
				xR:500,
				yB:386,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF011_PDRPLQ",
				originalFontSize:138,
				primaryFontColor:"black",
				xL:10,
				yT:200,
				xR:500,
				yB:386,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF012_PDRPLQ",
				originalFontSize:138,
				primaryFontColor:"black",
				xL:10,
				yT:200,
				xR:500,
				yB:386,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF014_PDRPLQ",
				originalFontSize:138,
				primaryFontColor:"black",
				xL:10,
				yT:200,
				xR:500,
				yB:386,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF015_PDRPLQ",
				originalFontSize:138,
				primaryFontColor:"black",
				xL:10,
				yT:200,
				xR:500,
				yB:386,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF017_PDRPLQ",
				originalFontSize:110,
				primaryFontColor:"black",
				xL:12,
				yT:200,
				xR:498,
				yB:388,
				bespokeValue:"melanie's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF018_PDRPLQ",
				originalFontSize:110,
				primaryFontColor:"black",
				xL:12,
				yT:200,
				xR:498,
				yB:388,
				bespokeValue:"melanie's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF020_PDRPLQ",
				originalFontSize:138,
				primaryFontColor:"black",
				xL:10,
				yT:200,
				xR:500,
				yB:386,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF021_PDRPLQ",
				originalFontSize:138,
				primaryFontColor:"black",
				xL:10,
				yT:200,
				xR:500,
				yB:386,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF025_PDRPLQ",
				originalFontSize:138,
				primaryFontColor:"black",
				xL:10,
				yT:200,
				xR:500,
				yB:386,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF027_PDRPLQ",
				originalFontSize:138,
				primaryFontColor:"black",
				xL:10,
				yT:200,
				xR:500,
				yB:386,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF029_PDRPLQ",
				originalFontSize:138,
				primaryFontColor:"black",
				xL:10,
				yT:200,
				xR:500,
				yB:386,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF030_PDRPLQ",
				originalFontSize:138,
				primaryFontColor:"black",
				xL:10,
				yT:200,
				xR:500,
				yB:386,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF033_PDRPLQ",
				originalFontSize:138,
				primaryFontColor:"black",
				xL:10,
				yT:200,
				xR:500,
				yB:386,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF035_PDRPLQ",
				originalFontSize:138,
				primaryFontColor:"black",
				xL:10,
				yT:200,
				xR:500,
				yB:386,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF036_PDRPLQ",
				originalFontSize:138,
				primaryFontColor:"black",
				xL:10,
				yT:200,
				xR:500,
				yB:386,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF037_PDRPLQ",
				originalFontSize:138,
				primaryFontColor:"black",
				xL:10,
				yT:200,
				xR:500,
				yB:386,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF038_PDRPLQ",
				originalFontSize:138,
				primaryFontColor:"black",
				xL:10,
				yT:200,
				xR:500,
				yB:386,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:699,
				canvasWidth:1024
			});
			//===============
			// ENAMEL MUGS
			//===============
			productArray.push({
				sku:"PMIFF005_PEM",
				originalFontSize:47,
				primaryFontColor:"black",
				xL:57,
				yT:70,
				xR:380,
				yB:125,
				bespokeValue:"melanie",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF008_PEM",
				originalFontSize:47,
				primaryFontColor:"black",
				xL:57,
				yT:60,
				xR:380,
				yB:122,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF010_PEM",
				originalFontSize:47,
				primaryFontColor:"black",
				xL:57,
				yT:42,
				xR:380,
				yB:107,
				bespokeValue:"miffy",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF011_PEM",
				originalFontSize:49,
				primaryFontColor:"black",
				xL:57,
				yT:112,
				xR:381,
				yB:187,
				bespokeValue:"miffy!",
				bespokeSuffix:"!",
				bespokeSuffix2:"!",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF012_PEM",
				originalFontSize:48,
				primaryFontColor:"black",
				xL:57,
				yT:102,
				xR:381,
				yB:181,
				bespokeValue:"miffy",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF014_PEM",
				originalFontSize:47,
				primaryFontColor:"black",
				xL:56,
				yT:53,
				xR:380,
				yB:115,
				bespokeValue:"miffy",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF015_PEM",
				originalFontSize:48,
				primaryFontColor:"black",
				xL:57,
				yT:82,
				xR:381,
				yB:165,
				bespokeValue:"miffy",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF017_PEM",
				originalFontSize:48,
				primaryFontColor:"black",
				xL:57,
				yT:82,
				xR:381,
				yB:165,
				bespokeValue:"melanie",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF018_PEM",
				originalFontSize:47,
				primaryFontColor:"black",
				xL:56,
				yT:55,
				xR:380,
				yB:118,
				bespokeValue:"melanie",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF020_PEM",
				originalFontSize:47,
				primaryFontColor:"black",
				xL:56,
				yT:60,
				xR:380,
				yB:135,
				bespokeValue:"miffy",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF021_PEM",
				originalFontSize:47,
				primaryFontColor:"black",
				xL:56,
				yT:58,
				xR:380,
				yB:145,
				bespokeValue:"miffy",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF025_PEM",
				originalFontSize:47,
				primaryFontColor:"black",
				xL:56,
				yT:65,
				xR:380,
				yB:152,
				bespokeValue:"miffy",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF027_PEM",
				originalFontSize:47,
				primaryFontColor:"black",
				xL:56,
				yT:45,
				xR:382,
				yB:152,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF029_PEM",
				originalFontSize:47,
				primaryFontColor:"black",
				xL:56,
				yT:98,
				xR:380,
				yB:160,
				bespokeValue:"miffy",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF030_PEM",
				originalFontSize:47,
				primaryFontColor:"black",
				xL:56,
				yT:108,
				xR:380,
				yB:185,
				bespokeValue:"miffy",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF033_PEM",
				originalFontSize:47,
				primaryFontColor:"black",
				xL:56,
				yT:108,
				xR:380,
				yB:185,
				bespokeValue:"miffy",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF035_PEM",
				originalFontSize:47,
				primaryFontColor:"black",
				xL:56,
				yT:80,
				xR:380,
				yB:152,
				bespokeValue:"miffy",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF036_PEM",
				originalFontSize:47,
				primaryFontColor:"black",
				xL:56,
				yT:100,
				xR:380,
				yB:180,
				bespokeValue:"miffy",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF037_PEM",
				originalFontSize:47,
				primaryFontColor:"black",
				xL:56,
				yT:110,
				xR:380,
				yB:180,
				bespokeValue:"miffy!",
				bespokeSuffix:"!",
				bespokeSuffix2:"!",
				canvasHeight:291,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF038_PEM",
				originalFontSize:47,
				primaryFontColor:"black",
				xL:56,
				yT:68,
				xR:380,
				yB:130,
				bespokeValue:"miffy",
				canvasHeight:291,
				canvasWidth:1024
			});
			//===============
			// LUNCH BOX
			//===============
			productArray.push({
				sku:"PMIFF005_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:46,
				yT:240,
				xR:500,
				yB:350,
				bespokeValue:"melanie's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF008_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:46,
				yT:240,
				xR:500,
				yB:350,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF010_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:46,
				yT:240,
				xR:500,
				yB:350,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF011_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:46,
				yT:240,
				xR:500,
				yB:350,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF012_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:40,
				yT:305,
				xR:500,
				yB:415,
				bespokeValue:"miffy",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF014_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:48,
				yT:240,
				xR:500,
				yB:350,
				bespokeValue:"miffy",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF015_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:48,
				yT:240,
				xR:500,
				yB:350,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF017_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:48,
				yT:240,
				xR:500,
				yB:350,
				bespokeValue:"melanie's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF018_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:45,
				yT:240,
				xR:500,
				yB:350,
				bespokeValue:"melanie",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF020_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:50,
				yT:234,
				xR:500,
				yB:350,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF021_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:48,
				yT:234,
				xR:500,
				yB:350,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF025_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:48,
				yT:236,
				xR:500,
				yB:352,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF027_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:48,
				yT:236,
				xR:500,
				yB:352,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF029_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:46,
				yT:256,
				xR:500,
				yB:390,
				bespokeValue:"miffy",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF030_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:48,
				yT:310,
				xR:510,
				yB:410,
				bespokeValue:"miffy",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF033_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:46,
				yT:232,
				xR:500,
				yB:360,
				bespokeValue:"miffy",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF035_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:46,
				yT:232,
				xR:500,
				yB:360,
				bespokeValue:"miffy",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF036_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:46,
				yT:300,
				xR:500,
				yB:422,
				bespokeValue:"miffy",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF037_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:46,
				yT:232,
				xR:500,
				yB:360,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:653,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF038_PLUNCHBOX",
				originalFontSize:65,
				primaryFontColor:"black",
				xL:46,
				yT:230,
				xR:500,
				yB:360,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:653,
				canvasWidth:1024
			});
			//===============
			// MAGNETS
			//===============
			productArray.push({
				sku:"PMIFF005_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:40,
				yT:16,
				xR:660,
				yB:150,
				bespokeValue:"melanie",
				canvasHeight:1024,
				canvasWidth:710
			});
			productArray.push({
				sku:"PMIFF008_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:54,
				yT:16,
				xR:660,
				yB:150,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:710
			});
			productArray.push({
				sku:"PMIFF010_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:70,
				yT:20,
				xR:955,
				yB:180,
				bespokeValue:"miffy",
				canvasHeight:710,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF011_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:54,
				yT:16,
				xR:660,
				yB:150,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:710
			});
			productArray.push({
				sku:"PMIFF012_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:54,
				yT:16,
				xR:660,
				yB:150,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:710
			});
			productArray.push({
				sku:"PMIFF014_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:54,
				yT:16,
				xR:660,
				yB:150,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:710
			});
			productArray.push({
				sku:"PMIFF015_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:54,
				yT:16,
				xR:660,
				yB:150,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:710
			});
			productArray.push({
				sku:"PMIFF017_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:54,
				yT:16,
				xR:645,
				yB:150,
				bespokeValue:"melanie",
				canvasHeight:1024,
				canvasWidth:710
			});
			productArray.push({
				sku:"PMIFF018_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:54,
				yT:16,
				xR:645,
				yB:150,
				bespokeValue:"melanie",
				canvasHeight:1024,
				canvasWidth:710
			});
			productArray.push({
				sku:"PMIFF020_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:54,
				yT:16,
				xR:660,
				yB:150,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:710
			});
			productArray.push({
				sku:"PMIFF021_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:54,
				yT:16,
				xR:660,
				yB:150,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:710
			});
			productArray.push({
				sku:"PMIFF025_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:54,
				yT:16,
				xR:660,
				yB:150,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:710
			});
			productArray.push({
				sku:"PMIFF027_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:20,
				yT:60,
				xR:475,
				yB:230,
				bespokeValue:"miffy",
				canvasHeight:710,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF029_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:54,
				yT:16,
				xR:660,
				yB:150,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:710
			});
			productArray.push({
				sku:"PMIFF030_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:54,
				yT:96,
				xR:660,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:710
			});
			productArray.push({
				sku:"PMIFF033_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:54,
				yT:16,
				xR:660,
				yB:150,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:710
			});
			productArray.push({
				sku:"PMIFF035_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:54,
				yT:16,
				xR:660,
				yB:150,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:710
			});
			productArray.push({
				sku:"PMIFF036_PMAG",
				originalFontSize:108,
				primaryFontColor:"black",
				xL:54,
				yT:136,
				xR:660,
				yB:278,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:710
			});
			productArray.push({
				sku:"PMIFF037_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:54,
				yT:16,
				xR:660,
				yB:150,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:710
			});
			productArray.push({
				sku:"PMIFF038_PMAG",
				originalFontSize:112,
				primaryFontColor:"black",
				xL:424,
				yT:16,
				xR:965,
				yB:184,
				bespokeValue:"miffy",
				canvasHeight:710,
				canvasWidth:1024
			});
			//===============
			// PENCIL TINS
			//===============
			productArray.push({
				sku:"PMIFF005_PPENTIN",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:93,
				yT:124,
				xR:488,
				yB:218,
				bespokeValue:"melanie's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF008_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:90,
				yT:121,
				xR:488,
				yB:216,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF010_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:85,
				yT:121,
				xR:488,
				yB:216,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF011_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:85,
				yT:150,
				xR:480,
				yB:250,
				bespokeValue:"miffy",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF012_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:85,
				yT:150,
				xR:480,
				yB:250,
				bespokeValue:"miffy",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF014_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:90,
				yT:121,
				xR:498,
				yB:216,
				bespokeValue:"miffy",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF015_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:90,
				yT:121,
				xR:498,
				yB:216,
				bespokeValue:"miffy",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF017_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:70,
				yT:121,
				xR:518,
				yB:216,
				bespokeValue:"melanie",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF018_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:70,
				yT:121,
				xR:515,
				yB:216,
				bespokeValue:"melanie",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF020_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:70,
				yT:121,
				xR:510,
				yB:218,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF021_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:70,
				yT:121,
				xR:510,
				yB:216,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF025_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:48,
				yT:142,
				xR:500,
				yB:256,
				bespokeValue:"miffy",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF027_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:70,
				yT:121,
				xR:506,
				yB:215,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF029_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:48,
				yT:142,
				xR:510,
				yB:256,
				bespokeValue:"miffy",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF030_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:48,
				yT:192,
				xR:510,
				yB:276,
				bespokeValue:"miffy",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF033_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:48,
				yT:192,
				xR:525,
				yB:273,
				bespokeValue:"miffy",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF035_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:80,
				yT:124,
				xR:500,
				yB:218,
				bespokeValue:"miffy",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF036_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:75,
				yT:192,
				xR:508,
				yB:278,
				bespokeValue:"miffy",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF037_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:45,
				yT:112,
				xR:520,
				yB:228,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:400,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF038_PPENTIN",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:55,
				yT:112,
				xR:525,
				yB:225,
				bespokeValue:"miffy",
				canvasHeight:400,
				canvasWidth:1024
			});
			//===============
			// PLACEMATS
			//===============
			productArray.push({
				sku:"PMIFF005_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:300,
				xR:520,
				yB:422,
				bespokeValue:"melanie",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF008_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:260,
				xR:512,
				yB:402,
				bespokeValue:"miffy",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF010_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:300,
				xR:518,
				yB:416,
				bespokeValue:"miffy",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF011_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:270,
				xR:518,
				yB:390,
				bespokeValue:"miffy's",
                bespokeSuffix:"'s",
                bespokeSuffix2:"'",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF012_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:350,
				xR:520,
				yB:450,
				bespokeValue:"miffy",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF014_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:310,
				xR:520,
				yB:410,
				bespokeValue:"miffy",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF015_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:256,
				xR:516,
				yB:360,
				bespokeValue:"miffy",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF017_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:276,
				xR:518,
				yB:388,
				bespokeValue:"melanie",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF018_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:320,
				xR:520,
				yB:408,
				bespokeValue:"melanie",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF020_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:40,
				yT:285,
				xR:480,
				yB:368,
				bespokeValue:"miffy",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF021_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:285,
				xR:508,
				yB:368,
				bespokeValue:"miffy",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF025_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:300,
				xR:520,
				yB:420,
				bespokeValue:"miffy",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF027_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:275,
				xR:520,
				yB:380,
				bespokeValue:"miffy",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF029_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:310,
				xR:520,
				yB:410,
				bespokeValue:"miffy",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF030_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:340,
				xR:520,
				yB:445,
				bespokeValue:"miffy",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF033_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:353,
				xR:513,
				yB:445,
				bespokeValue:"miffy",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF035_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:300,
				xR:520,
				yB:380,
				bespokeValue:"miffy",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF036_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:333,
				xR:515,
				yB:435,
				bespokeValue:"miffy",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF037_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:310,
				xR:518,
				yB:410,
				bespokeValue:"miffy",
				canvasHeight:734,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF038_PPLCMT",
				originalFontSize:71,
				primaryFontColor:"black",
				xL:50,
				yT:275,
				xR:518,
				yB:370,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:734,
				canvasWidth:1024
			});
			//===============
			// PRINT
			//===============
			productArray.push({
				sku:"PMIFF005_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:170,
				xR:824,
				yB:270,
				bespokeValue:"melanie",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF008_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:175,
				xR:824,
				yB:270,
				bespokeValue:"miffy!",
				bespokeSuffix:"!",
				bespokeSuffix2:"!",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF010_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:95,
				xR:824,
				yB:200,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF011_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:95,
				xR:824,
				yB:185,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF012_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:175,
				xR:822,
				yB:255,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF014_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:95,
				xR:824,
				yB:185,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF015_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:95,
				xR:824,
				yB:185,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF017_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:95,
				xR:824,
				yB:185,
				bespokeValue:"melanie",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF018_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:95,
				xR:824,
				yB:185,
				bespokeValue:"melanie",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF020_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:110,
				xR:824,
				yB:195,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF021_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:110,
				xR:824,
				yB:195,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF025_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:180,
				xR:825,
				yB:263,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF027_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:90,
				xR:824,
				yB:185,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF029_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:90,
				xR:824,
				yB:190,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF030_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:170,
				xR:825,
				yB:243,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF033_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:90,
				xR:824,
				yB:185,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF035_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:90,
				xR:824,
				yB:185,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF036_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:180,
				xR:825,
				yB:263,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF037_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:95,
				xR:824,
				yB:195,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF038_PPRINT",
				originalFontSize:81,
				primaryFontColor:"black",
				xL:198,
				yT:115,
				xR:824,
				yB:218,
				bespokeValue:"miffy",
				canvasHeight:1021,
				canvasWidth:1024
			});
			//===============
			// TOTES
			//===============
			productArray.push({
				sku:"PMIFF005_PTOTE",
				originalFontSize:77,
				primaryFontColor:"black",
				xL:20,
				yT:2,
				xR:576,
				yB:76,
				bespokeValue:"melanie",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF008_PTOTE",
				originalFontSize:77,
				primaryFontColor:"black",
				xL:20,
				yT:10,
				xR:576,
				yB:88,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF010_PTOTE",
				originalFontSize:76,
				primaryFontColor:"black",
				xL:20,
				yT:18,
				xR:576,
				yB:114,
				bespokeValue:"miffy",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF011_PTOTE",
				originalFontSize:77,
				primaryFontColor:"black",
				xL:20,
				yT:5,
				xR:576,
				yB:86,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF012_PTOTE",
				originalFontSize:77,
				primaryFontColor:"black",
				xL:20,
				yT:75,
				xR:576,
				yB:160,
				bespokeValue:"miffy",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF014_PTOTE",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:20,
				yT:2,
				xR:556,
				yB:82,
				bespokeValue:"miffy",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF015_PTOTE",
				originalFontSize:85,
				primaryFontColor:"black",
				xL:20,
				yT:10,
				xR:576,
				yB:100,
				bespokeValue:"miffy",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF017_PTOTE",
				originalFontSize:75,
				primaryFontColor:"black",
				xL:36,
				yT:25,
				xR:556,
				yB:100,
				bespokeValue:"melanie",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF018_PTOTE",
				originalFontSize:64,
				primaryFontColor:"black",
				xL:38,
				yT:2,
				xR:558,
				yB:66,
				bespokeValue:"melanie",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF020_PTOTE",
				originalFontSize:74,
				primaryFontColor:"black",
				xL:38,
				yT:2,
				xR:556,
				yB:80,
				bespokeValue:"miffy",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF021_PTOTE",
				originalFontSize:74,
				primaryFontColor:"black",
				xL:38,
				yT:2,
				xR:556,
				yB:80,
				bespokeValue:"miffy",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF025_PTOTE",
				originalFontSize:70,
				primaryFontColor:"black",
				xL:38,
				yT:50,
				xR:556,
				yB:138,
				bespokeValue:"miffy",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF027_PTOTE",
				originalFontSize:74,
				primaryFontColor:"black",
				xL:38,
				yT:20,
				xR:558,
				yB:122,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF029_PTOTE",
				originalFontSize:85,
				primaryFontColor:"black",
				xL:38,
				yT:10,
				xR:556,
				yB:100,
				bespokeValue:"miffy",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF030_PTOTE",
				originalFontSize:75,
				primaryFontColor:"black",
				xL:38,
				yT:55,
				xR:558,
				yB:150,
				bespokeValue:"miffy",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF033_PTOTE",
				originalFontSize:74,
				primaryFontColor:"black",
				xL:38,
				yT:6,
				xR:560,
				yB:85,
				bespokeValue:"miffy",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF035_PTOTE",
				originalFontSize:74,
				primaryFontColor:"black",
				xL:38,
				yT:6,
				xR:560,
				yB:83,
				bespokeValue:"miffy",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF036_PTOTE",
				originalFontSize:74,
				primaryFontColor:"black",
				xL:38,
				yT:79,
				xR:560,
				yB:158,
				bespokeValue:"miffy",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF037_PTOTE",
				originalFontSize:75,
				primaryFontColor:"black",
				xL:38,
				yT:8,
				xR:560,
				yB:88,
				bespokeValue:"miffy's",
				bespokeSuffix:"'s",
				bespokeSuffix2:"'",
				canvasHeight:842,
				canvasWidth:596
			});
			productArray.push({
				sku:"PMIFF038_PTOTE",
				originalFontSize:84,
				primaryFontColor:"black",
				xL:40,
				yT:8,
				xR:802,
				yB:90,
				bespokeValue:"miffy",
				canvasHeight:596,
				canvasWidth:842
			});
			//===============
			// TEA TOWELS
			//===============
			productArray.push({
				sku:"PMIFF005_PTT",
				originalFontSize:84,
				primaryFontColor:"black",
				xL:40,
				yT:8,
				xR:666,
				yB:90,
				bespokeValue:"melanie",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF008_PTT",
				originalFontSize:108,
				primaryFontColor:"black",
				xL:40,
				yT:5,
				xR:666,
				yB:123,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF010_PTT",
				originalFontSize:84,
				primaryFontColor:"black",
				xL:52,
				yT:5,
				xR:668,
				yB:94,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF011_PTT",
				originalFontSize:108,
				primaryFontColor:"black",
				xL:40,
				yT:5,
				xR:666,
				yB:123,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF012_PTT",
				originalFontSize:85,
				primaryFontColor:"black",
				xL:52,
				yT:85,
				xR:650,
				yB:164,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF014_PTT",
				originalFontSize:108,
				primaryFontColor:"black",
				xL:40,
				yT:5,
				xR:666,
				yB:123,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF015_PTT",
				originalFontSize:108,
				primaryFontColor:"black",
				xL:40,
				yT:5,
				xR:666,
				yB:123,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF017_PTT",
				originalFontSize:85,
				primaryFontColor:"black",
				xL:40,
				yT:5,
				xR:666,
				yB:94,
				bespokeValue:"melanie",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF018_PTT",
				originalFontSize:85,
				primaryFontColor:"black",
				xL:40,
				yT:5,
				xR:666,
				yB:94,
				bespokeValue:"melanie",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF020_PTT",
				originalFontSize:108,
				primaryFontColor:"black",
				xL:40,
				yT:5,
				xR:666,
				yB:123,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF021_PTT",
				originalFontSize:108,
				primaryFontColor:"black",
				xL:40,
				yT:5,
				xR:666,
				yB:123,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF025_PTT",
				originalFontSize:108,
				primaryFontColor:"black",
				xL:40,
				yT:5,
				xR:666,
				yB:123,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF027_PTT",
				originalFontSize:108,
				primaryFontColor:"black",
				xL:40,
				yT:5,
				xR:666,
				yB:123,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF029_PTT",
				originalFontSize:108,
				primaryFontColor:"black",
				xL:40,
				yT:5,
				xR:666,
				yB:123,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF030_PTT",
				originalFontSize:98,
				primaryFontColor:"black",
				xL:40,
				yT:100,
				xR:666,
				yB:208,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF033_PTT",
				originalFontSize:98,
				primaryFontColor:"black",
				xL:40,
				yT:100,
				xR:666,
				yB:218,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF035_PTT",
				originalFontSize:78,
				primaryFontColor:"black",
				xL:40,
				yT:5,
				xR:666,
				yB:96,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF036_PTT",
				originalFontSize:98,
				primaryFontColor:"black",
				xL:40,
				yT:100,
				xR:666,
				yB:218,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF037_PTT",
				originalFontSize:108,
				primaryFontColor:"black",
				xL:40,
				yT:5,
				xR:666,
				yB:123,
				bespokeValue:"miffy",
				canvasHeight:1024,
				canvasWidth:706
			});
			productArray.push({
				sku:"PMIFF038_PTT",
				originalFontSize:60,
				primaryFontColor:"black",
				xL:190,
				yT:2,
				xR:834,
				yB:65,
				bespokeValue:"miffy",
				canvasHeight:706,
				canvasWidth:1024
			});
			//===============
			// WATER BOTTLES
			//===============
			productArray.push({
				sku:"PMIFF005_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:482,
				yB:230,
				bespokeValue:"melanie",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF008_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:482,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF010_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:482,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF011_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:482,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF012_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:20,
				yT:160,
				xR:465,
				yB:243,
				bespokeValue:"miffy",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF014_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:482,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF015_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:482,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF017_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:155,
				xR:482,
				yB:240,
				bespokeValue:"melanie",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF018_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:155,
				xR:482,
				yB:240,
				bespokeValue:"melanie",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF020_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:482,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF021_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:482,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF025_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:482,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF027_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:482,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF029_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:482,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF030_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:482,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF033_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:482,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF035_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:482,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF036_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:482,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF037_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:482,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:401,
				canvasWidth:1024
			});
			productArray.push({
				sku:"PMIFF038_PWATERBOTTLE",
				originalFontSize:63,
				primaryFontColor:"black",
				xL:30,
				yT:160,
				xR:482,
				yB:240,
				bespokeValue:"miffy",
				canvasHeight:401,
				canvasWidth:1024
			});
			for (var i = 0; i < productArray.length; i++) {
				//--------
				//PRIMARY
				//--------
				_sku = productArray[i].sku;
				_originalFontSize = productArray[i].originalFontSize;
				_xL = productArray[i].xL;
				_yT = productArray[i].yT;
				_xR = productArray[i].xR;
				_yB = productArray[i].yB;
				_canvasHeight = productArray[i].canvasHeight;
				_canvasWidth = productArray[i].canvasWidth;
				//--------
				//OPTIONAL
				//--------
				_bespokeValue = productArray[i].bespokeValue;
				_bespokeSuffix = productArray[i].bespokeSuffix;
				_bespokeSuffix2 = productArray[i].bespokeSuffix2;
				_bespokePrefix = productArray[i].bespokePrefix;
				_primaryFontColor = productArray[i].primaryFontColor;
				_verticalAlignment = productArray[i].verticalAlignment;
				_fontSizeRatio = productArray[i].fontSizeRatio;
				_caseRule = productArray[i].caseRule;
				_horizontalAlignment = productArray[i].horizontalAlignment;
				_fontFamilyBase = productArray[i].fontFamilyBase;
				_primaryFontColor2 = productArray[i].primaryFontColor2;
				_dropshadowScale = productArray[i].dropshadowScale;
				_stroke = productArray[i].stroke;
				_strokeScale = productArray[i].strokeScale;
				_strokeColor = productArray[i].strokeColor;
				_strokeWidth = productArray[i].strokeWidth;
				_shadowFontColor = productArray[i].shadowFontColor;
				_shadowBlur = productArray[i].shadowBlur;
				_shadowOffsetX = productArray[i].shadowOffsetX;
				_shadowOffsetY = productArray[i].shadowOffsetY;
				_dropshadow = productArray[i].dropshadow;
				_dropshadowScale = productArray[i].dropshadowScale;
				_centerRotationDeg = productArray[i].centerRotationDeg;
				_centerRotationX = productArray[i].centerRotationX;
				_centerRotationY = productArray[i].centerRotationY;
				_zoom = productArray[i].zoom;                
              
				if(pcode==_sku){
					//--------
					//PRIMARY
					//--------
					sku = _sku;
					if(_originalFontSize){originalFontSize = _originalFontSize;};
					if(_xL){xL = _xL;};
					if(_yT){yT = _yT;};
					if(_xR){xR = _xR;};
					if(_yB){yB = _yB;};
					if(_canvasHeight){canvasHeight = _canvasHeight;};
					if(_canvasWidth){canvasWidth = _canvasWidth;};
					//--------
					//OPTIONAL
					//--------
					if(_bespokeValue){bespokeValue = _bespokeValue;};
					if(_bespokeSuffix){bespokeSuffix = _bespokeSuffix;};
					if(_bespokeSuffix2){bespokeSuffix2 = _bespokeSuffix2;};
					if(_bespokePrefix){bespokePrefix = _bespokePrefix;};
					if(_primaryFontColor){primaryFontColor = _primaryFontColor;};					
					if(_verticalAlignment){verticalAlignment = _verticalAlignment;};
					if(_fontSizeRatio){fontSizeRatio = _fontSizeRatio;};
					if(_caseRule){caseRule = _caseRule;};
					if(_horizontalAlignment){horizontalAlignment = _horizontalAlignment;};
					if(_fontFamilyBase){fontFamilyBase = _fontFamilyBase;};
					if(_primaryFontColor2){primaryFontColor2 = _primaryFontColor2;};
					if(_strokeScale){strokeScale = _strokeScale;};
					if(_dropshadowScale){dropshadowScale = _dropshadowScale;};
					if(_stroke){stroke = _stroke;};
					if(_strokeColor){strokeColor = _strokeColor;};
					if(_strokeWidth){strokeWidth = _strokeWidth;};
					if(_shadowFontColor){shadowFontColor = _shadowFontColor;};
					if(_shadowBlur){shadowBlur = _shadowBlur;};
					if(_shadowOffsetX){shadowOffsetX = _shadowOffsetX;};
					if(_shadowOffsetY){shadowOffsetY = _shadowOffsetY;};
					if(_dropshadow){dropshadow = _dropshadow;};
					if(_dropshadowScale){dropshadowScale = _dropshadowScale;};
					if(_centerRotationDeg){centerRotationDeg = _centerRotationDeg;};
					if(_centerRotationX){centerRotationX = _centerRotationX;};
					if(_centerRotationY){centerRotationY = _centerRotationY;};
					if(_zoom){zoom = _zoom;};
					//--------
					if(debug){
						console.log(i+" MATCH! "+sku);
					}

                  // For logging 
                  if(_xL){window.personalisationCoordsXL = _xL;};
				  if(_yT){window.personalisationCoordsYT = _yT;};
				  if(_xR){window.personalisationCoordsXR = _xR;};
    			  if(_yB){window.personalisationCoordsYB = _yB;};

                  if(_bespokeSuffix){
                    window.personalisationBespokeSuffix = _bespokeSuffix;
                  }else{
                    window.personalisationBespokeSuffix = '';
                  };
                  if(_bespokePrefix){
                    window.personalisationBespokePrefix = _bespokePrefix;
                  }else{
                    window.personalisationBespokePrefix = '';
                  };
				}
			}
			//resize canvas to image size
			if(zoom){
				originalFontSize = originalFontSize*zoom;
				xL = xL*zoom;
				yT = yT*zoom;
				xR = xR*zoom;
				yB = yB*zoom;
				canvasHeight = canvasHeight*zoom;
				canvasWidth = canvasWidth*zoom;				
			}
			$("#canvas").attr({width: canvasWidth,height: canvasHeight}).css({maxWidth:canvasWidth});
			if(debug){
				var imageType = "TEXT";
			}else{
				var imageType = "BLANK";
			}
			$("#canvas").css('background-image', "url('http://d18vs3cajeo1y7.cloudfront.net/miffy/"+pcode+"_"+imageType+".jpg')");
			$("#title").css({
			    textTransform : caseRule
			});
			String.prototype.capitalize = function() {
			    return this.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
			};
			function writeStuff(){
				var sizeMultiplier = originalFontSize/100;
				var gradTop;
				var gradBottom;
				var fontFamily = fontFamilyBase;
			    var stringTitle = document.getElementById('title').value;
			    switch (caseRule){
					case 'capitalize':
						stringTitle = stringTitle.toLowerCase().capitalize();
						$('#title').val(stringTitle);
					break;
					case 'lowercase':
						stringTitle = stringTitle.toLowerCase();
						$('#title').val(stringTitle);
					break; 
					case 'uppercase':
						stringTitle = stringTitle.toUpperCase();
						$('#title').val(stringTitle);
					break;
					default:
						//do nothing
					break;
				}
			    if (stringTitle){
				    if(bespokeSuffix 
				    && bespokeSuffix != stringTitle.substr(-bespokeSuffix.length) 
				    && bespokeSuffix.substr(0,bespokeSuffix.length-1) != stringTitle.substr(-bespokeSuffix.length+1)){
					    if(stringTitle.substr(-1) != "S" && stringTitle.substr(-1) != "s"){
					    	stringTitle = stringTitle.concat(bespokeSuffix);
				    	}else{
					    	stringTitle = stringTitle.concat(bespokeSuffix2);
				    	}
				    }else if(bespokeSuffix 
				    && bespokeSuffix == stringTitle.substr(-bespokeSuffix.length)){
					    newStringTitle = stringTitle.slice(0,-bespokeSuffix.length);
						$('#title').val(newStringTitle);
				    }else if(bespokeSuffix 
				    && bespokeSuffix.substr(0,bespokeSuffix.length-1) == stringTitle.substr(-bespokeSuffix.length+1)){
					    newStringTitle = stringTitle.slice(0,-bespokeSuffix.length+1);
						$('#title').val(newStringTitle);
				    }
				    if(bespokePrefix){
					    stringTitle = bespokePrefix.concat(""+stringTitle);
				    }
				}
			    if(!stringTitle || stringTitle == bespokeSuffix){
				    stringTitle = bespokeValue;
			    }
			    ctx.fillStyle = "rgba(255, 255, 255, 0)";
			    ctx.clearRect(0, 0, canvas.width, canvas.height);
			    ctx.fillRect(0, 0, canvas.width, canvas.height);
			    ctx.fillStyle = '#6F9E94';	    
				newFontSize = originalFontSize*ratio;
			    ctx.font = originalFontSize+'px '+fontFamily;
			    ctx.textAlign = horizontalAlignment;
			    var text_title = stringTitle;
			    var textWidth = ctx.measureText(stringTitle).width;
			    if(textWidth>(xR-xL)){
				    ratio = ((xR-xL)/textWidth)*.95;
			    }else{
				    ratio = originalRatio;
			    }
				newFontSize = originalFontSize*ratio;
				newFontPosX = canvas.width/2-(newFontSize*.02);
				if(horizontalAlignment == 'left'){
					newFontPosX = xL;
				}
				if(horizontalAlignment == 'center'){
					newFontPosX = xL+(xR-xL)/2;
				}
				if(horizontalAlignment == 'right'){
					newFontPosX = xL+(xR-xL);					
				}
				newFontPosY = canvas.height / 2 + 35*sizeMultiplier;
				if(verticalAlignment == 'top'){
					newFontPosY = yT - 30 * fontSizeRatio * ratio;
					ctx.textBaseline = 'top';
					gradTop = yT;
					gradBottom = yB;
				}
				if(verticalAlignment == 'center'){
					newFontPosY = yT + (yB-yT)/2 + (newFontSize/fontSizeRatio/2);
					gradTop = yT + (yB-yT)/2 - (newFontSize/3);
					gradBottom = yT + (yB-yT)/2 + (newFontSize/3);
				}
				if(verticalAlignment == 'bottom'){
					newFontPosY = yB;
					gradTop = yB - (newFontSize*.5)*sizeMultiplier;
					gradBottom = yB;
				}
				ctx.font = newFontSize+'px '+fontFamily;				
				if(debug || showBounds){
					ctx.beginPath();
					ctx.rect(xL, yT, xR-xL, yB-yT);
					ctx.strokeStyle = 'rgba(255,0,0,0.5)';
					ctx.stroke();
				}
			    if(dropshadow){
				    ctx.shadowColor = shadowFontColor;
				    ctx.shadowBlur = shadowBlur;
				    if(dropshadowScale){
					    ctx.shadowOffsetX = (shadowOffsetX/originalFontSize)*newFontSize;
						ctx.shadowOffsetY = (shadowOffsetY/originalFontSize)*newFontSize;
					}else{
					    ctx.shadowOffsetX = (shadowOffsetX/originalFontSize)*newFontSize/ratio;
						ctx.shadowOffsetY = (shadowOffsetY/originalFontSize)*newFontSize/ratio;
					}
					if(centerRotationDeg){
						degree_amt = 180 / centerRotationDeg;
						ctx.save();
						ctx.translate(centerRotationX, centerRotationY);
						ctx.rotate(-Math.PI / degree_amt);						
						ctx.textAlign = 'center';
						ctx.fillText(stringTitle, 0, newFontPosY);
						ctx.restore();
					}else{
					    ctx.fillText(stringTitle, newFontPosX, newFontPosY);	
					}
			    }
			    ctx.shadowBlur = 0;
			    ctx.shadowOffsetX = 0;
			    ctx.shadowOffsetY = 0;
			    if(stroke2){
					ctx.miterLimit = 2.5;
					ctx.strokeStyle = strokeColor2;
				    ctx.lineWidth = Math.floor(newFontSize*strokeWidth2);
				    console.log ("lineWidth: "+Math.floor(newFontSize*strokeWidth2));
				    ctx.shadowColor = strokeColor2;
				    ctx.shadowBlur = strokeBlur2;
					if(centerRotationDeg){
						degree_amt = 180 / centerRotationDeg;
						ctx.save();
						ctx.translate(centerRotationX, centerRotationY);
						ctx.rotate(-Math.PI / degree_amt);						
						ctx.textAlign = 'center';
						ctx.strokeText(stringTitle, 0, newFontPosY);
						ctx.restore();
					}else{
						ctx.strokeText(stringTitle, newFontPosX, newFontPosY);
					}
			    }
			    ctx.shadowBlur = 0;
			    if(stroke){
					ctx.miterLimit = 2.5;
					ctx.strokeStyle = strokeColor;
					if(strokeScale){
						_strokeWidth = strokeWidth;	
					}else{
						_strokeWidth = strokeWidth / ratio;		
					}
				    ctx.lineWidth = Math.floor(newFontSize*strokeWidth);
					if(centerRotationDeg){
						degree_amt = 180 / centerRotationDeg;
						ctx.save();
						ctx.translate(centerRotationX, centerRotationY);
						ctx.rotate(-Math.PI / degree_amt);
						
						ctx.textAlign = 'center';
						ctx.strokeText(stringTitle, 0, newFontPosY);
						ctx.restore();
					}else{
						ctx.strokeText(stringTitle, newFontPosX, newFontPosY);
					}
					if(strokeWidth > .09){
				    	ctx.lineWidth = Math.floor(newFontSize*.09);
						ctx.strokeText(stringTitle, newFontPosX, newFontPosY);
					}
			    }
				ctx.lineWidth = 1;
				ctx.miterLimit = 0;
			    if(primaryFontColor2){
					var grdOffset = (gradBottom-gradTop)*gradOffset;
					if(gradientDirection == "horizontal"){
			    		var grd = ctx.createLinearGradient(textWidth/2*gradOffset,25,-textWidth/2*gradOffset,0);
					}else{
						var grd = ctx.createLinearGradient(0, gradTop+grdOffset, 0, gradBottom-grdOffset);
			    	}
			    	grd.addColorStop(0, primaryFontColor);
			    	grd.addColorStop(1, primaryFontColor2);	
					ctx.fillStyle = grd;				
				}else{
				    ctx.fillStyle = primaryFontColor;
				}
				if(centerRotationDeg){
					degree_amt = 180 / centerRotationDeg;
					ctx.save();
					ctx.translate(centerRotationX, centerRotationY);
					ctx.rotate(-Math.PI / degree_amt);
					
					ctx.textAlign = 'center';
					ctx.fillText(stringTitle, 0, newFontPosY);
					
					ctx.restore();
					if(debug){
						ctx.fillStyle = 'red';
						ctx.fillRect(centerRotationX, centerRotationY, 3, 3);
					}
				}else{
				    ctx.fillText(stringTitle, newFontPosX, newFontPosY);
			    }
			    textWidth = ctx.measureText(stringTitle).width;
              	customTextValue = stringTitle;
			    if(debug){
			    	console.log("Canvas Width: " + canvas.width);
			    	console.log("textWidth: " + textWidth);
			    	console.log("Ratio: " + ratio);
			    	console.log("Size Multiplier: " + sizeMultiplier);
			    	console.log("Text Y Pos: " + newFontPosY);
			    	console.log("gradTop: " + gradTop);
			    	console.log("gradBottom: " + gradBottom);
			    	console.log("stringTitle: " + stringTitle);
			    }
			}
			document.getElementById('title').addEventListener('keyup', function() {
				writeStuff();
			});
			fontSpy(fontFamilyBase, {
				success: function() {
					if(debug){
						console.log("font '"+fontFamilyBase+"' loaded successfully");
					}
					writeStuff();
					setInterval(writeStuff, 500);
				},
				failure: function() {
					if(debug){
						console.log("font '"+fontFamilyBase+"' failed to load");
					}
					writeStuff();
				}
			});
			$("input").alphanum({
				allow              : '\'&+!=/,.!@£$%^&*()_+}{|":?><~/.,\';][-`',
			    disallow           : '',
			    allowSpace         : true,
			    allowNumeric       : true,
			    allowUpper         : true,
			    allowLower         : true,
			    allowCaseless      : true,
			    allowLatin         : true,
			    allowOtherCharSets : true,
			    forceUpper         : false,
			    forceLower         : false,
			    maxLength          : NaN
			});
		}
	}	
})( this, jQuery );